import type { FC } from 'react';

interface DownloadIconProps {
  color?: string;
}

export const DownloadIcon: FC<DownloadIconProps> = ({ color = '#E6E6E9' }) => (
  <svg width="100%" height="100%" viewBox="0 0 10 10" fill="none">
    <path
      d="M7.91668 6.25V8.75M7.91668 8.75L7.08334 7.91667M7.91668 8.75L8.75001 7.91667M5.41668 1.25H3.41668C2.94997 1.25 2.71661 1.25 2.53835 1.34083C2.38155 1.42072 2.25406 1.5482 2.17417 1.70501C2.08334 1.88327 2.08334 2.11662 2.08334 2.58333V7.41667C2.08334 7.88337 2.08334 8.11675 2.17417 8.295C2.25406 8.45179 2.38155 8.57929 2.53835 8.65917C2.71661 8.75 2.94997 8.75 3.41668 8.75H5.83334M5.41668 1.25L7.91668 3.75M5.41668 1.25V3.08333C5.41668 3.31669 5.41668 3.43337 5.46209 3.5225C5.50205 3.6009 5.56576 3.66464 5.64418 3.70459C5.7333 3.75 5.84997 3.75 6.08334 3.75H7.91668M7.91668 3.75V4.58333M3.75001 7.08333H5.41668M3.75001 5.41667H6.25001M3.75001 3.75H4.16668"
      stroke={color}
      stroke-width="0.833333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
